import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Modal} from '@softline/ui-core';
import {BehaviorSubject} from 'rxjs';
import {Comment} from '../../types/comment';
import {CommonModule} from '@angular/common';

import { MultilineInputComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'lib-create-comment-dialog',
    imports: [CommonModule,
    MultilineInputComponent,
    TranslatePipe],
    templateUrl: './create-comment-dialog.component.html',
    styleUrls: ['./create-comment-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateCommentDialogComponent implements OnInit, Modal<{ content: string } | undefined> {

  // tslint:disable-next-line:variable-name
  private _comment?: Comment;
  readonly isEditing$ = new BehaviorSubject(false);

  close!: (result: ({ content: string } | undefined)) => void;

  get comment(): Comment | undefined {
    return this._comment;
  }
  set comment(value: Comment | undefined) {
    this._comment = value;
    this.isEditing$.next(!!value);

    if (!!value) {
      this.input$.next(value?.kommentar ?? '');
    }
  }

  readonly input$ = new BehaviorSubject('');

  constructor() { }

  ngOnInit(): void { }

  registerCloseHandler(handler: (result: ({ content: string } | undefined)) => void) {
    this.close = handler;
  }
}
